import React from 'react';
import { Link } from 'react-router-dom';

import { Button, Heading, Stack, Text } from '@eluve/components';

export const ErrorPage: React.FC<{ reset?: () => void }> = ({ reset }) => {
  return (
    <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        <Text size="md" weight="semibold" className="text-text-accent-primary">
          Error
        </Text>
        <Heading className="mt-4">We're sorry</Heading>
        <Text size="md" color="tertiary" className="mt-6 leading-7">
          It seems like something went wrong. The team has been notified and
          we're working on fixing it.
        </Text>
        <Stack
          className="mt-10 gap-x-6"
          direction="horizontal"
          align="center"
          justify="center"
        >
          <Button variant={'outline'} onClick={reset}>
            Try again
          </Button>
          <Link
            to="/"
            className="rounded-md bg-bg-accent-strong-secondary px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-bg-accent-strong-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-border-accent-quaternary"
            onClick={reset}
          >
            Go back home
          </Link>
        </Stack>
      </div>
    </main>
  );
};
